import React, {FC} from 'react';
import BaseButton from "../form/Button";
import {IBrands} from "../../constants/types";

interface IBrandsList {
    brands: Array<IBrands>,
    handleBrandsId: any,
    activeHardnessId: number,
    activeBrandsId: Array<number>
}

const BrandsList: FC<IBrandsList> = ({
                                         brands,
                                         handleBrandsId,
                                         activeBrandsId,
                                         activeHardnessId
                                     }) => {
    const availableBrands = brands.filter((el: any) => el.hardness.find((el: number) => el === activeHardnessId));

    return (
        <div className="tastes__list">
            {
                brands.map((el: IBrands) => {
                    const isButtonActive = activeBrandsId.find((number: number) => number === el.id);
                    const isButtonAvailable = availableBrands.find((item: any) => item.id === el.id);
                    if (isButtonActive === el.id && !isButtonAvailable)
                        handleBrandsId(el.id);
                    return (
                        <BaseButton
                            key={el.id}
                            isPreferenceButton
                            isActive={!!isButtonActive && !!isButtonAvailable}
                            isDisabled={!isButtonAvailable}
                            onClick={() => handleBrandsId(el.id)}
                        >
                            {el.name}
                        </BaseButton>
                    );
                })
            }
        </div>
    );
};

export default BrandsList;
